{
  "eyebrow": "Secure AI connection",
  "title": "Connect {{clientName}} to Elements",
  "description": "{{clientName}} is requesting read-only access to {{firmName}} in Elements. Review the permissions before continuing.",
  "client-label": "Requesting app",
  "firm-label": "Elements firm",
  "access-summary-label": "This connection can access",
  "permissions-title": "Permissions",
  "permissions-description": "Elements will grant only the permissions listed here. You can revoke this connection later.",
  "allow-button": "Allow {{clientName}}",
  "deny-button": "Deny",
  "restart-eyebrow": "Connection expired",
  "restart-title": "Restart the connection",
  "restart-description": "This authorization request is no longer active. Return to the requesting app and start the Elements connection again.",
  "invalid-eyebrow": "Invalid request",
  "invalid-title": "We cannot continue this connection",
  "invalid-description": "{{message}}. Return to the requesting app and start the Elements connection again.",
  "invalid-reason-ai-connections-disabled": "AI Connections is not enabled for this firm",
  "invalid-reason-ai-disabled": "AI is disabled for this firm",
  "invalid-reason-firm-not-found": "Firm not found",
  "invalid-reason-invalid-consent-intent": "Invalid consent intent",
  "invalid-reason-invalid-consent-origin": "Invalid consent origin",
  "invalid-reason-invalid-oauth-redirect-uri": "Invalid OAuth redirect URI",
  "invalid-reason-missing-request-id": "Missing mcp_request_id",
  "invalid-reason-single-firm-required": "AI Connections could not verify your active firm",
  "scope-generic": "Grant {{scope}} permission to the requesting app.",
  "scope-read-client-profile": "View basic client profile details.",
  "scope-read-financial-summary": "View client financial summary data.",
  "scope-read-scorecard": "View Elements scorecard data.",
  "scope-read-firm": "View firm context needed to answer client questions.",
  "scope-profile-read": "View your Elements identity and firm membership.",
  "scope-clients-read": "View this firm's households and clients.",
  "scope-scores-read": "View Elements scores and vitals for this firm's clients.",
  "scope-notes-read": "View advisor notes on this firm's clients.",
  "scope-firm-read": "View this firm's settings."
}
